import { useParams } from "react-router-dom";
import type { ReplenishmentRunResource } from "@exonn/js-sdk";
import { ResourceEnum } from "src/constants/constants.ts";
import { useOne } from "src/system/useOne.tsx";
import { useResourceFormData } from "src/components/Form/hooks/useResourceFormData.ts";
import type { ReplenishmentRunFormData } from "src/admin/modules/replenishment-run/forms/replenishment-run/config.tsx";

const POLL_INTERVAL = 2_000;

const isActive = (run: ReplenishmentRunResource | null | undefined) =>
  run?.status === "pending" || run?.status === "running";

/**
 * Прогон считается в очереди: форма следит за ним лёгким запросом к show
 * (статус прогона и процесс с процентом), пока он не завершится.
 */
export const useRunProgress = () => {
  const { id } = useParams();
  const formRun = useResourceFormData<ReplenishmentRunFormData>()?.data;

  const { data } = useOne<ReplenishmentRunResource>({
    resource: ResourceEnum.ReplenishmentRun,
    id: id!,
    includes: ["process"],
    queryOptions: {
      enabled: !!id,
      staleTime: 0,
      gcTime: 0,
      refetchInterval: (query) =>
        isActive(query.state.data?.data) ? POLL_INTERVAL : false,
    },
  });

  const run = data?.data ?? formRun ?? null;

  return {
    run,
    isRunning: isActive(run),
    hasFailed: run?.status === "failed",
  };
};
